import React from 'react';

interface ScoreInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
}

export function ScoreInput({
  value,
  onChange,
  disabled = false,
  placeholder = '–',
  className = '',
}: ScoreInputProps) {
  const handleStep = (delta: number) => {
    const num = parseInt(value, 10);
    const next = isNaN(num) ? Math.max(0, delta) : Math.max(0, num + delta);
    onChange(String(next));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\D/g, '');
    onChange(raw);
  };

  return (
    <div
      className={[
        'flex w-20 h-[50px] rounded-btn overflow-hidden border-2 font-nunito',
        disabled
          ? 'border-border-neutral bg-bg-inputSoft'
          : 'border-brand-blue bg-bg-input',
        className,
      ].join(' ')}
    >
      {/* Numeric input */}
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={value}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeholder}
        className={[
          'flex-1 min-w-0 text-center text-[22px] font-[800] bg-transparent',
          'focus:outline-none pl-2',
          disabled ? 'text-text-muted cursor-not-allowed' : 'text-text-primary',
        ].join(' ')}
      />

      {/* Stepper column */}
      {!disabled && (
        <div className="flex flex-col w-7 border-l border-brand-blue flex-shrink-0">
          <button
            type="button"
            tabIndex={-1}
            onClick={() => handleStep(1)}
            className="flex-1 flex items-center justify-center text-brand-blue hover:bg-brand-blue/10 transition-colors text-[10px] font-bold"
          >
            ▲
          </button>
          <div className="h-px bg-brand-blue/30" />
          <button
            type="button"
            tabIndex={-1}
            onClick={() => handleStep(-1)}
            className="flex-1 flex items-center justify-center text-brand-blue hover:bg-brand-blue/10 transition-colors text-[10px] font-bold"
          >
            ▼
          </button>
        </div>
      )}
    </div>
  );
}
